"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mobilePushPayloadV1Schema = exports.disableMobilePushInstallationResponseV1Schema = exports.registerMobilePushInstallationAcrossWorkspacesResponseV1Schema = exports.registerMobilePushInstallationResponseV1Schema = exports.mobilePushInstallationSchema = exports.registerMobilePushInstallationRequestV1Schema = exports.expoPushTokenSchema = exports.mobilePushInstallationIdSchema = exports.mobilePushPlatformSchema = exports.updateNotificationSettingRequestSchema = exports.updateTeamNotificationSettingRequestSchema = exports.updateCustomerNotificationSettingRequestSchema = exports.notificationSettingsResponseSchema = exports.teamNotificationSettingSchema = exports.customerNotificationSettingSchema = exports.editableNotificationEmailTemplateSchema = exports.notificationTemplateVariableSchema = exports.teamNotificationDeliveryMethodsSchema = exports.customerNotificationDeliveryMethodsSchema = exports.teamNotificationRecipientSchema = exports.teamNotificationGroupSchema = exports.customerNotificationGroupSchema = exports.customerNotificationEventKeySchema = exports.markAllNotificationsReadResponseSchema = exports.markCrossWorkspaceNotificationReadResponseSchema = exports.markNotificationReadResponseSchema = exports.notificationWorkspaceUnreadSummaryResponseSchema = exports.notificationWorkspaceUnreadSummaryItemSchema = exports.notificationUnreadCountResponseSchema = exports.crossWorkspaceNotificationListResponseSchema = exports.notificationListResponseSchema = exports.notificationListQuerySchema = exports.crossWorkspaceNotificationSchema = exports.notificationWorkspaceSchema = exports.inAppNotificationSchema = exports.inAppNotificationTypeSchema = exports.notificationReadFilterSchema = exports.notificationIdSchema = exports.MOBILE_PUSH_INSTALLATION_CONTRACT_VERSION = exports.NOTIFICATION_SETTINGS_CONTRACT_VERSION = exports.NOTIFICATION_CONTRACT_VERSION = void 0;
const zod_1 = require("zod");
const pagination_1 = require("./pagination");
exports.NOTIFICATION_CONTRACT_VERSION = 1;
exports.NOTIFICATION_SETTINGS_CONTRACT_VERSION = 1;
exports.MOBILE_PUSH_INSTALLATION_CONTRACT_VERSION = 1;
exports.notificationIdSchema = zod_1.z.string().uuid();
exports.notificationReadFilterSchema = zod_1.z
    .enum(["ALL", "UNREAD"])
    .default("ALL");
exports.inAppNotificationTypeSchema = zod_1.z.enum([
    "APPOINTMENT_ASSIGNED",
    "APPOINTMENT_ASSIGNMENT_REQUIRED",
    "APPOINTMENT_RESCHEDULED",
    "APPOINTMENT_CANCELED",
    "ESTIMATE_ACCEPTED",
    "ESTIMATE_DECLINED",
    "INVOICE_PAID",
    "PAYMENT_FAILED",
    "PAYMENT_REFUNDED",
    "PAYMENT_REFUND_FAILED",
    "PAYMENT_RECONCILIATION_REQUIRED",
    "PAYMENT_DISPUTE_ACTION_REQUIRED",
    "PAYMENT_DISPUTE_UPDATED",
    "TEAM_INVITATION",
    "LEAD_UNASSIGNED",
    "JOB_INBOX_REQUEST_RECEIVED",
    "CUSTOMER_MESSAGE_RECEIVED",
    "VOICE_VOICEMAIL_RECEIVED",
    "PENDING_PIPELINE_FOLLOW_UP",
]);
exports.inAppNotificationSchema = zod_1.z.object({
    id: exports.notificationIdSchema,
    type: exports.inAppNotificationTypeSchema,
    title: zod_1.z.string().trim().min(1).max(160),
    body: zod_1.z.string().trim().min(1).max(500),
    deepLink: zod_1.z
        .string()
        .max(2_048)
        .regex(/^\/(?!\/)/),
    createdAt: zod_1.z.string().datetime({ offset: true }),
    readAt: zod_1.z.string().datetime({ offset: true }).nullable(),
});
exports.notificationWorkspaceSchema = zod_1.z.object({
    tenantId: zod_1.z.string().uuid(),
    tenantName: zod_1.z.string().trim().min(1).max(160),
    businessId: zod_1.z.string().uuid(),
    businessName: zod_1.z.string().trim().min(1).max(160),
});
exports.crossWorkspaceNotificationSchema = exports.inAppNotificationSchema.extend({
    workspace: exports.notificationWorkspaceSchema,
});
exports.notificationListQuerySchema = pagination_1.paginationQuerySchema.extend({
    readFilter: exports.notificationReadFilterSchema,
});
exports.notificationListResponseSchema = zod_1.z.object({
    items: zod_1.z.array(exports.inAppNotificationSchema),
    total: zod_1.z.number().int().nonnegative(),
    pageInfo: pagination_1.pageInfoSchema.default(pagination_1.defaultPageInfo),
});
exports.crossWorkspaceNotificationListResponseSchema = zod_1.z.object({
    items: zod_1.z.array(exports.crossWorkspaceNotificationSchema),
    total: zod_1.z.number().int().nonnegative(),
    pageInfo: pagination_1.pageInfoSchema.default(pagination_1.defaultPageInfo),
});
exports.notificationUnreadCountResponseSchema = zod_1.z.object({
    unreadCount: zod_1.z.number().int().nonnegative(),
});
exports.notificationWorkspaceUnreadSummaryItemSchema = zod_1.z.object({
    workspace: exports.notificationWorkspaceSchema,
    unreadCount: zod_1.z.number().int().nonnegative(),
});
exports.notificationWorkspaceUnreadSummaryResponseSchema = zod_1.z.object({
    items: zod_1.z.array(exports.notificationWorkspaceUnreadSummaryItemSchema),
});
exports.markNotificationReadResponseSchema = zod_1.z.object({
    notification: exports.inAppNotificationSchema,
});
exports.markCrossWorkspaceNotificationReadResponseSchema = zod_1.z.object({
    notification: exports.crossWorkspaceNotificationSchema,
});
exports.markAllNotificationsReadResponseSchema = zod_1.z.object({
    markedReadCount: zod_1.z.number().int().nonnegative(),
    unreadCount: zod_1.z.literal(0),
});
exports.customerNotificationEventKeySchema = zod_1.z.enum([
    "JOB_SCHEDULED",
    "JOB_ON_MY_WAY",
    "JOB_FINISHED",
    "JOB_REMINDER",
    "JOB_CANCELED",
    "ESTIMATE_SCHEDULED",
    "ESTIMATE_ON_MY_WAY",
    "ESTIMATE_FINISHED",
    "ESTIMATE_SENT",
    "ESTIMATE_CANCELED",
    "INVOICE_SENT",
    "INVOICE_REMINDER",
    "INVOICE_REFUND",
    "INVOICE_RECEIPT",
]);
exports.customerNotificationGroupSchema = zod_1.z.enum([
    "JOBS",
    "ESTIMATES",
    "INVOICES",
]);
exports.teamNotificationGroupSchema = zod_1.z.enum([
    "SCHEDULE",
    "ESTIMATES",
    "INVOICES_AND_PAYMENTS",
    "TEAM",
    "LEADS_AND_INBOX",
    "VOICE",
]);
exports.teamNotificationRecipientSchema = zod_1.z.enum([
    "ASSIGNEES",
    "OWNERS",
    "ADMINS",
    "DISPATCHERS",
]);
exports.customerNotificationDeliveryMethodsSchema = zod_1.z.object({
    email: zod_1.z.boolean(),
    sms: zod_1.z.boolean(),
});
exports.teamNotificationDeliveryMethodsSchema = zod_1.z.object({
    browser: zod_1.z.boolean(),
    email: zod_1.z.boolean(),
    notificationCenter: zod_1.z.boolean(),
    push: zod_1.z.boolean(),
});
exports.notificationTemplateVariableSchema = zod_1.z.object({
    key: zod_1.z
        .string()
        .trim()
        .regex(/^[a-z][a-z0-9_]*$/)
        .max(80),
    label: zod_1.z.string().trim().min(1).max(120),
    sample: zod_1.z.string().max(500),
});
exports.editableNotificationEmailTemplateSchema = zod_1.z.object({
    subject: zod_1.z.string().trim().min(1).max(375),
    body: zod_1.z.string().trim().min(1).max(20_000),
});
exports.customerNotificationSettingSchema = zod_1.z.object({
    audience: zod_1.z.literal("CUSTOMER"),
    eventKey: exports.customerNotificationEventKeySchema,
    group: exports.customerNotificationGroupSchema,
    label: zod_1.z.string().trim().min(1).max(120),
    description: zod_1.z.string().trim().min(1).max(500),
    connected: zod_1.z.boolean(),
    deliveryMethods: exports.customerNotificationDeliveryMethodsSchema,
    emailTemplate: exports.editableNotificationEmailTemplateSchema.extend({
        variables: zod_1.z.array(exports.notificationTemplateVariableSchema),
    }),
    defaultEmailTemplate: exports.editableNotificationEmailTemplateSchema,
});
exports.teamNotificationSettingSchema = zod_1.z.object({
    audience: zod_1.z.literal("TEAM"),
    eventKey: exports.inAppNotificationTypeSchema,
    group: exports.teamNotificationGroupSchema,
    label: zod_1.z.string().trim().min(1).max(120),
    description: zod_1.z.string().trim().min(1).max(500),
    deliveryMethods: exports.teamNotificationDeliveryMethodsSchema,
    recipients: zod_1.z.array(exports.teamNotificationRecipientSchema),
});
exports.notificationSettingsResponseSchema = zod_1.z.object({
    contractVersion: zod_1.z.literal(exports.NOTIFICATION_SETTINGS_CONTRACT_VERSION),
    canManage: zod_1.z.boolean(),
    customer: zod_1.z.array(exports.customerNotificationSettingSchema),
    team: zod_1.z.array(exports.teamNotificationSettingSchema),
});
exports.updateCustomerNotificationSettingRequestSchema = zod_1.z.object({
    contractVersion: zod_1.z.literal(exports.NOTIFICATION_SETTINGS_CONTRACT_VERSION),
    audience: zod_1.z.literal("CUSTOMER"),
    eventKey: exports.customerNotificationEventKeySchema,
    deliveryMethods: exports.customerNotificationDeliveryMethodsSchema,
    emailTemplate: exports.editableNotificationEmailTemplateSchema,
});
exports.updateTeamNotificationSettingRequestSchema = zod_1.z
    .object({
    contractVersion: zod_1.z.literal(exports.NOTIFICATION_SETTINGS_CONTRACT_VERSION),
    audience: zod_1.z.literal("TEAM"),
    eventKey: exports.inAppNotificationTypeSchema,
    deliveryMethods: exports.teamNotificationDeliveryMethodsSchema,
    recipients: zod_1.z.array(exports.teamNotificationRecipientSchema),
})
    .superRefine((value, context) => {
    const hasDeliveryMethod = Object.values(value.deliveryMethods).some(Boolean);
    if (hasDeliveryMethod && !value.recipients.length) {
        context.addIssue({
            code: "custom",
            path: ["recipients"],
            message: "Choose at least one recipient when delivery is enabled.",
        });
    }
});
exports.updateNotificationSettingRequestSchema = zod_1.z.discriminatedUnion("audience", [
    exports.updateCustomerNotificationSettingRequestSchema,
    exports.updateTeamNotificationSettingRequestSchema,
]);
exports.mobilePushPlatformSchema = zod_1.z.enum(["ANDROID", "IOS"]);
exports.mobilePushInstallationIdSchema = zod_1.z.string().uuid();
exports.expoPushTokenSchema = zod_1.z
    .string()
    .trim()
    .min(1)
    .max(255)
    .regex(/^(?:ExponentPushToken|ExpoPushToken)\[[^\]\r\n]+\]$/);
exports.registerMobilePushInstallationRequestV1Schema = zod_1.z.object({
    contractVersion: zod_1.z.literal(exports.MOBILE_PUSH_INSTALLATION_CONTRACT_VERSION),
    installationId: exports.mobilePushInstallationIdSchema,
    expoPushToken: exports.expoPushTokenSchema,
    platform: exports.mobilePushPlatformSchema,
    projectId: zod_1.z.string().uuid(),
    appVersion: zod_1.z.string().trim().min(1).max(64).nullable().default(null),
});
exports.mobilePushInstallationSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    installationId: exports.mobilePushInstallationIdSchema,
    platform: exports.mobilePushPlatformSchema,
    status: zod_1.z.enum(["ACTIVE", "DISABLED"]),
    registeredAt: zod_1.z.string().datetime({ offset: true }),
    disabledAt: zod_1.z.string().datetime({ offset: true }).nullable(),
});
exports.registerMobilePushInstallationResponseV1Schema = zod_1.z.object({
    installation: exports.mobilePushInstallationSchema,
});
exports.registerMobilePushInstallationAcrossWorkspacesResponseV1Schema = zod_1.z.object({
    installations: zod_1.z.array(zod_1.z.object({
        tenantId: zod_1.z.string().uuid(),
        businessId: zod_1.z.string().uuid(),
        installation: exports.mobilePushInstallationSchema,
    })),
});
exports.disableMobilePushInstallationResponseV1Schema = zod_1.z.object({
    installationId: exports.mobilePushInstallationIdSchema,
    status: zod_1.z.literal("DISABLED"),
    disabledAt: zod_1.z.string().datetime({ offset: true }),
});
exports.mobilePushPayloadV1Schema = zod_1.z.object({
    contractVersion: zod_1.z.literal(exports.MOBILE_PUSH_INSTALLATION_CONTRACT_VERSION),
    notificationId: exports.notificationIdSchema,
    businessId: zod_1.z.string().uuid(),
    deepLink: zod_1.z
        .string()
        .max(2_048)
        .regex(/^\/(?!\/)/),
});
//# sourceMappingURL=notification.js.map